import { formatDateToBR } from "../../../../../utils/time";
import { SETableColumnsProps } from "../../../../components/SETable";
import { Grid, IconButton } from "@mui/material";
import {
  RiCheckboxCircleFill,
  RiCloseCircleFill,
  RiDeleteBin6Line,
  RiErrorWarningFill,
  RiFileCopy2Fill,
  RiPencilLine,
} from "react-icons/ri";
import React from "react";
import SETableIconButton from "../../../../components/SETable/SETableIconButton";
import { formatInstrumentString } from "../../../../../utils/utils";
import { formatDefaultValueSelect } from "../../../../../utils/mask";

interface TableColumnsProps {
  handleEdit?: (data?: any) => void;
  handleCopy?: (data?: any) => void;
  handleUpdateStatus?: (data?: any) => void;
  handleDelete?: (id?: number | string) => void;
}

export const tableColumns = ({
  handleEdit = () => {},
  handleCopy = () => {},
  handleDelete = () => {},
  handleUpdateStatus = () => {},
}: TableColumnsProps): SETableColumnsProps[] => [
  {
    id: "dataCriacao",
    label: "Data",
    customField: formatDateToBR,
  },
  {
    id: "uf",
    label: "UF",
    align: "left",
    customField: (uf: any) => uf?.sigla,
  },
  {
    id: "nome",
    label: "Nome da regra",
    align: "left",
  },
  {
    id: "publicos",
    label: "Público",
    align: "left",
    customField: (publicos: any) =>
      publicos?.map((p: any) => p.nome).join(", ") ?? "",
  },
  {
    id: "instrumento",
    label: "Instrumento",
    align: "left",
    customField: formatInstrumentString,
  },
  {
    id: "temaMacro",
    label: "Tema",
    align: "left",
    customField: (temaMacro: any) => temaMacro?.descricao,
  },
  {
    id: "periodos",
    label: "Duração",
    align: "left",
    customField: (d) =>
      d
        ?.map(
          (i: any) =>
            `${i.duracao}${
              i.unidadeMedida === "HORA"
                ? "h"
                : i.unidadeMedida === "MINUTO"
                ? "m"
                : "s"
            }`
        )
        .join(", "),
  },
  {
    id: "perfil",
    label: "Perfil",
    align: "left",
    customField: (perfil: any) => formatDefaultValueSelect(perfil.nome),
  },
  {
    id: "projetos",
    label: "Projeto",
    align: "left",
    customField: (projetos: any) =>
      projetos?.map((i: any) => i.nomePratif).join(", ") ?? "",
  },
  {
    id: "status",
    label: "Status",
    align: "center",
    width: 320,
    sortable: false,
    customField: (value: any, row: any) => (
      <Grid container justifyContent="center" alignItems="center">
        <Grid item md={6} container alignItems="center" justifyContent="center">
          <IconButton onClick={() => handleUpdateStatus(row)}>
            <>
              {value === "APROVADO" && (
                <RiCheckboxCircleFill
                  size={26}
                  color="#66BD91"
                  title={"Aprovado"}
                />
              )}
              {(value === "PENDENTE" || value === null) && (
                <RiErrorWarningFill
                  size={26}
                  color="#F6E566"
                  title={"Pendente"}
                />
              )}
              {value === "REPROVADO" && (
                <RiCloseCircleFill
                  size={26}
                  color="#FF0000"
                  title={"Reprovado"}
                />
              )}
            </>
          </IconButton>
          <SETableIconButton onClick={() => handleEdit(row)}>
            <RiPencilLine size={20} color="#555770" />
          </SETableIconButton>
          <SETableIconButton onClick={() => handleCopy(row)}>
            <RiFileCopy2Fill size={20} color="#555770" />
          </SETableIconButton>
          <SETableIconButton onClick={() => handleDelete(row.id)}>
            <RiDeleteBin6Line size={20} color="#555770" />
          </SETableIconButton>
        </Grid>
      </Grid>
    ),
  },
];
